import { useMutation } from '@tanstack/react-query';

import { ValidatorAccountFormSchemaValues } from 'src/features/validatorAccounts/utils/formSchema';
import { ValidatorAccount } from 'src/features/validatorAccounts/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/validations/validator-account/:id/`;

type MutationFnType = typeof mutationFn;

interface DTO extends ValidatorAccountFormSchemaValues {
    id: string;
    parkingId: string;
}
const mutationFn = ({ id, ...data }: DTO): Promise<ValidatorAccount> => {
    return axios.patch(formatResourcePath(RESOURCE, { id }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateValidatorAccount };
